<template>
    <div>
        <st-button
            variant="secondary"
            :callback="addDocumentSeriesType"
        >
            <i class="fa fa-plus"></i>
            {{ $t('DOCUMENT_SERIES_TYPE.ADD_BUTTON') }}
        </st-button>

        <document-series-type-form-modal
            v-if="showModal"
            ref="documentSeriesTypeFormModal"
            @close="dismissModal"
            :edit-mode="editMode"
        ></document-series-type-form-modal>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import DocumentSeriesTypeFormModal from '@/modules/document-series-type/components/DocumentSeriesTypeFormModal.vue';

    export default {
        name: 'DocumentSeriesTypeListToolbar',
        components: { DocumentSeriesTypeFormModal },
        watch: {
            openEditing(newValue, oldValue) {
                if (newValue === oldValue || !newValue) return false;
                this.editMode = true;
                this.showModal = true;
          }
        },
        data() {
            return {
                showModal: false,
                editMode: false,
            };
        },
        computed: {
            ...mapGetters({
                record: 'documentSeriesType/form/record',
                openEditing: 'documentSeriesType/form/openEditing'
            }),
        },
        methods: {
            ...mapActions({
                unselectRecord: 'documentSeriesType/form/unselect',
            }),
            addDocumentSeriesType() {
                this.showModal = true;
                this.editMode = false;
            },
            dismissModal() {
                this.showModal = false;
                if (this.editMode) {
                    this.unselectRecord();
                }
            }
        }
    };
</script>
